import { createFileRoute, Outlet } from '@tanstack/react-router';
import { AclRoute, EngagementAclKeys, withPermission } from '@/lib/acl';

// Layout route — gates the whole /engagements/* subtree behind the engagements
// listing-read UI permission-key (ENT-284). Fail-closed; the BE authorizes every
// real call regardless of what renders here. Requires acl-svc to expose
// `myPermissions` and grant `engagements:listing_read` (+ `/sync-ui-permissions`).
export const Route = createFileRoute('/engagements')({
  component: withPermission(Outlet, {
    key: EngagementAclKeys.listingRead,
    route: AclRoute.ENGAGEMENT,
    resourceLabel: 'Engagements',
  }),
});
